import { Calendar, Clock, CheckCircle } from "lucide-react"

interface AvailableSlot {
  id: string
  startTime: string
  endTime: string
  isSelected: boolean
}

interface TimelineCardProps {
  slot: AvailableSlot
  selectedSlot: string | null
  onSelect: (slotId: string) => void
}

export default function TimelineCard({
  slot,
  selectedSlot,
  onSelect,
}: TimelineCardProps) {
  const isSelected = selectedSlot === slot.id

  const slotDate = new Date(slot.startTime).toLocaleDateString("en-IN", {
    weekday: "short",
    year: "numeric",
    month: "short",
    day: "numeric",
  })

  const slotTime = new Date(slot.startTime).toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  })

  return (
    <div
      onClick={() => onSelect(slot.id)}
      className={`cursor-pointer bg-card rounded-2xl p-6 sm:p-8 shadow-lg hover:shadow-2xl transform hover:-translate-y-1 transition-all duration-300 border-2 ${
        isSelected
          ? "border-[#1b237a] bg-gradient-to-r from-blue-50 to-indigo-50 ring-4 ring-blue-100"
          : "border-transparent hover:border-blue-200"
      }`}
    >
      <div className="flex items-center justify-between flex-wrap gap-4">
        <div className="flex-1 min-w-[200px]">
          <div className="flex items-center gap-3 mb-2">
            <Calendar
              className={`w-5 h-5 sm:w-6 sm:h-6 ${
                isSelected ? "text-[#1b237a]" : "text-muted-foreground"
              }`}
            />
            <h3 className="text-lg sm:text-xl font-semibold text-foreground">
              {slotDate}
            </h3>
          </div>
          <div className="flex items-center gap-3 ml-0 sm:ml-9">
            <Clock
              className={`w-5 h-5 sm:w-6 sm:h-6 ${
                isSelected ? "text-[#1b237a]" : "text-muted-foreground"
              }`}
            />
            <p className="text-base sm:text-lg text-muted-foreground">
              {slotTime} SAST
            </p>
          </div>
        </div>
        <div
          className={`w-6 h-6 rounded-full border-2 flex items-center justify-center ${
            isSelected ? "border-[#1b237a] bg-[#1b237a]" : "border-border"
          }`}
        >
          {isSelected && <CheckCircle className="w-4 h-4 text-white" />}
        </div>
      </div>
    </div>
  )
}
